import { Theme } from '@chakra-ui/react'

type Params = {
  theme: Theme
  colorMode: 'light' | 'dark'
}

const text = {
  baseStyle: {
    lineHeight: '125%',
  },
  sizes: {
    sm: {
      fontSize: '0.875rem',
    },
  },
  variants: {
    secondary: ({ theme, colorMode }: Params) => {
      return {
        fontSize: 'xs',
        color: colorMode === 'light' ? theme.colors.gray['500'] : theme.colors.whiteAlpha['700'],
      }
    },
    short: ({ theme, colorMode }: Params) => {
      return {
        fontSize: 'xs',
        color: colorMode === 'light' ? theme.colors.gray['500'] : theme.colors.whiteAlpha['700'],
      }
    },
    noData: ({ theme, colorMode }: Params) => {
      return {
        fontSize: 'sm',
        fontStyle: 'italic',
        color: colorMode === 'light' ? theme.colors.gray['500'] : theme.colors.whiteAlpha['700'],
      }
    },
  },
  defaultProps: {},
}

export default text
